// extracted by mini-css-extract-plugin
export default {"container":"NY1Mv","form":"YPQCb","forgot":"Pjv5v"};